import { HackleUser, IdentifiersBuilder, IdentifierType } from "../model/model"
import { UserDecorator } from "../user/UserDecorator"
import ObjectUtil from "../util/ObjectUtil"
import { SessionManager } from "./SessionManager"

export default class SessionUserDecorator implements UserDecorator {
  constructor(private readonly sessionManager: SessionManager) {}

  decorate(user: HackleUser): HackleUser {
    if (user.identifiers[IdentifierType.SESSION]) return user

    const sessionId = this.sessionManager.currentSessionId
    if (ObjectUtil.isNullOrUndefined(sessionId)) return user

    const identifiers = new IdentifiersBuilder()
      .addIdentifiers(user.identifiers)
      .add(IdentifierType.SESSION, sessionId)
      .build()

    return {
      ...user,
      identifiers
    }
  }
}
